export default "__VITE_ASSET__xKN6$zI2__"